import { Outlet } from 'react-router-dom';

const Contacts = () => {
  return (
    <><Outlet /></>
  );
};

export default Contacts;